module.exports = __webpack_public_path__ + "img/amigos_-18_chino.f53cd648.webp";